import request from '@/utils/request'

export function exchangeImpersonationTicket(ticket) {
  return request({
    url: '/impersonation/exchange/',
    method: 'post',
    data: { ticket },
  })
}

export function revokeImpersonationTicket() {
  return request({
    url: '/impersonation/revoke/',
    method: 'post',
  })
}
